/* action type */
import type { Action } from '../../store/state/state-manager';

export const CREATE_WORK = 'CREATE_WORK';

/* action creator */
export const createWorkAction = (actionPayload: Action['payload']) => {
  return {
    type: CREATE_WORK,
    payload: actionPayload
  };
};
